import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { currentMonth } from '@/lib/utils'
import type { User } from '@/types'

export interface BackgroundImport {
  label: string          // "Import LinkedIn"
  done: number
  total: number
  status: 'running' | 'done' | 'error'
  error?: string
}

interface AppState {
  user: User | null
  authLoading: boolean   // true jusqu'à ce que Supabase confirme l'état d'auth initial
  selectedMonth: string
  sidebarCollapsed: boolean
  backgroundImport: BackgroundImport | null
  dashboardVersion: number

  setUser: (user: User | null) => void
  setAuthLoading: (v: boolean) => void
  setSelectedMonth: (month: string) => void
  setSidebarCollapsed: (v: boolean) => void
  setBackgroundImport: (v: BackgroundImport | null) => void
  incrementDashboardVersion: () => void
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      user: null,
      authLoading: true,
      selectedMonth: currentMonth(),
      sidebarCollapsed: false,
      backgroundImport: null,
      dashboardVersion: 0,

      setUser: (user) => set({ user }),
      setAuthLoading: (v) => set({ authLoading: v }),
      setSelectedMonth: (month) => set({ selectedMonth: month }),
      setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
      setBackgroundImport: (v) => set({ backgroundImport: v }),
      incrementDashboardVersion: () => set((state) => ({ dashboardVersion: state.dashboardVersion + 1 })),
    }),
    {
      name: 'recrutpro-store',
      partialize: (state) => ({
        selectedMonth: state.selectedMonth,
        sidebarCollapsed: state.sidebarCollapsed,
      }),
    },
  ),
)
